import { render, staticRenderFns } from "./ContestItem.vue?vue&type=template&id=36f8b89f"
import script from "./ContestItem.vue?vue&type=script&lang=ts"
export * from "./ContestItem.vue?vue&type=script&lang=ts"
import style0 from "./ContestItem.vue?vue&type=style&index=0&id=36f8b89f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports